import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LandingPageComponent } from './landing-page/landing-page.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { SideNavComponent } from './side-nav/side-nav.component';
import { TicketsModule } from './tickets/tickets.module';
import { LoginComponent } from './login/login.component';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import {  TopbarComponent} from './topbar/topbar.component';
// used to create fake backend
import { fakeBackendProvider } from './_helpers';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NotificationService } from './_services/notification.service';
import { RegisterComponent } from './register/register.component';
import { AllUsersComponent } from './all-users/all-users.component';
import { CustomersComponent } from './customers/customers.component'
import { MatTableModule } from '@angular/material/table';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { AuthService } from './_services/auth.service';
import { NewCustomersComponent } from './new-customers/new-customers.component';
import { SubscriptionComponent } from './subscription/subscription.component';
// Custom Material Inputs
import { MatInputModule } from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatDividerModule} from '@angular/material/divider';

// beak subscription component
import {BeakSubscriptionComponent} from './beak-subscription/beak-subscription.component';
import { BeakCustomerComponent } from './beak-subscription/beak-customer/beak-customer.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    SideNavComponent,
    LoginComponent,
    TopbarComponent,
    RegisterComponent,    
    AllUsersComponent,
    CustomersComponent,
    CustomerDetailComponent,
    UserDetailComponent,
    NewCustomersComponent,
    SubscriptionComponent,
    BeakSubscriptionComponent,
    BeakCustomerComponent // beak-subscription
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    TicketsModule,
    HttpClientModule,MatSelectModule,MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatInputModule, // Custom Material Inputs
    ToastrModule.forRoot(),
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatDividerModule,
   
  ],
  providers: [ { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  
    // provider used to create fake backend
    fakeBackendProvider,
    ToastrService,
    AuthService,
    NotificationService,
    
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
